import { memo } from 'react';
import { Box } from '@betty/moonlight';
import useStatus from '../../hooks/useStatus';
import {
  StatusInstructions,
  StatusResetDisclaimer,
  StatusTitleText,
} from '../../components';

function StatusInfo() {
  const { status } = useStatus();

  if (!status) {
    return null;
  }

  return (
    <Box alignItems="center" gap="space-400">
      <StatusTitleText locKey="status_info_title" />
      <StatusInstructions status={status} />
      <StatusResetDisclaimer status={status} />
    </Box>
  );
}

export default memo(StatusInfo);
